import { NavLink } from "react-router-dom";
import SearchBar from "../SearchBar/SearchBar";
import styles from "./HeaderMenu.module.scss";

function HeaderMenu() {
  return (
    <ul className={`${styles.menuContainer} p-10`}>
      <SearchBar />
      <NavLink to="/">
        <li key="pokemons">Pokemons</li>
      </NavLink>
    </ul>
  );
}

export default HeaderMenu;
